<template>
  <v-card>
    <v-toolbar card prominent top offet-y v-bind:class="{'fixedToolbar' : !drawer}" style="z-index: 2;">
      <v-toolbar-title class="headline grey-text">New Transfer</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click.native="addTransferCheck($v.currentTransfer)">
        <v-icon color="green">fas fa-check</v-icon>
      </v-btn>
      <v-btn icon @click.native="$router.push({ path: '/dashboard/transfer' })">
        <v-icon color="red">fas fa-times</v-icon>
      </v-btn>
    </v-toolbar>

    <v-card-text style="padding-top: 0;">
      <v-container grid-list-md v-bind:class="{'padContent': !drawer}">
        <v-layout wrap>
          <v-flex xs12>
            <v-select v-bind:items="currency"
                      label="Currency"
                      v-model="currentTransfer.currency"
                      :error-messages="currencyErrors"
                      @input="$v.currentTransfer.currency.$touch()"
                      @blur="$v.currentTransfer.currency.$touch()"
                      @change="selectedCurrencyChanged"></v-select>
          </v-flex>
          <v-flex xs12>
            <v-text-field v-model="currentTransfer.transferName"
                          label="Transfer Name"
                          :error-messages="transferNameErrors"
                          @input="$v.currentTransfer.transferName.$touch()"
                          @blur="$v.currentTransfer.transferName.$touch()"></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-autocomplete :items="account"
                            v-model="currentTransfer.transferFrom"
                            label="Transfer From Account"
                            item-text="accountName"
                            item-value="accountName"
                            chips
                            prepend-icon="fa-balance-scale"
                            hint="Transfer from Account?"
                            persistent-hint
                            :error-messages="transferFromErrors"
                            @input="$v.currentTransfer.transferFrom.$touch()"
                            @blur="$v.currentTransfer.transferFrom.$touch()">
              <template slot="selection" slot-scope="data">
                <v-chip @input="data.parent.selectItem(data.item)"
                        :selected="data.selected"
                        class="chip--select-multi"
                        :key="JSON.stringify(data.item)">

                  {{ data.item.accountName }}
                </v-chip>
              </template>
              <template slot="item" slot-scope="data">
                <template v-if="typeof data.item !== 'object'">
                  <v-list-tile-content v-text="data.item"></v-list-tile-content>
                </template>
                <template v-else>

                  <v-list-tile-content>
                    <v-list-tile-title v-text="data.item.accountName"></v-list-tile-title>

                  </v-list-tile-content>
                </template>
              </template>
            </v-autocomplete>
          </v-flex>
          <v-flex xs12>
            <v-autocomplete :items="account"
                            v-model="currentTransfer.transferTo"
                            label="Transfer To Account"
                            item-text="accountName"
                            item-value="accountName"
                            chips
                            prepend-icon="fa-balance-scale"
                            hint="Transfer To Account?"
                            persistent-hint
                            :error-messages="transferToErrors"
                            @input="$v.currentTransfer.transferTo.$touch()"
                            @blur="$v.currentTransfer.transferTo.$touch()">
              <template slot="selection" slot-scope="data">
                <v-chip @input="data.parent.selectItem(data.item)"
                        :selected="data.selected"
                        class="chip--select-multi"
                        :key="JSON.stringify(data.item)">

                  {{ data.item.accountName }}
                </v-chip>
              </template>
              <template slot="item" slot-scope="data">
                <template v-if="typeof data.item !== 'object'">
                  <v-list-tile-content v-text="data.item"></v-list-tile-content>
                </template>
                <template v-else>

                  <v-list-tile-content>
                    <v-list-tile-title v-text="data.item.accountName"></v-list-tile-title>
                  </v-list-tile-content>
                </template>
              </template>
            </v-autocomplete>
          </v-flex>
          <v-flex xs12>
            <v-autocomplete :items="category"
                            v-model="currentTransfer.category"
                            label="Category"
                            chips
                            prepend-icon="fa-tags"
                            hint="What Category does this belong to?"
                            persistent-hint
                            :error-messages="categoryErrors"
                            @input="$v.currentTransfer.category.$touch()"
                            @blur="$v.currentTransfer.category.$touch()"></v-autocomplete>
          </v-flex>
          <v-flex xs12>
            <v-text-field label="Transfer Amount" prepend-icon="fa-money-bill-alt" type="number" min="1"
                          v-model="currentTransfer.transferAmount"
                          :error-messages="transferAmountErrors"
                          @input="$v.currentTransfer.transferAmount.$touch()"
                          @blur="$v.currentTransfer.transferAmount.$touch()"></v-text-field>

          </v-flex>
          <v-flex xs12>
            <v-text-field label="Comment" prepend-icon="fa-comment" v-model="currentTransfer.comment"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-menu ref="datemenu"
                    lazy
                    :close-on-content-click="false"
                    v-model="datemenu"
                    transition="scale-transition"
                    offset-y
                    full-width
                    :nudge-right="40"
                    min-width="290px"
                    :return-value.sync="currentTransfer.transferDate">
              <v-text-field slot="activator"
                            label="Date Picker"
                            v-model="currentTransfer.transferDate"
                            prepend-icon="fa-calendar"
                            readonly></v-text-field>
              <v-date-picker v-model="currentTransfer.transferDate" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="datemenu = false">Cancel</v-btn>
                <v-btn flat color="primary" @click="$refs.datemenu.save(currentTransfer.transferDate)">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs6>
            <v-dialog ref="timemenu"
                      persistent
                      v-model="timemenuvisibilty"
                      lazy
                      full-width
                      width="290px"
                      :return-value.sync="currentTransfer.transferTime">
              <v-text-field slot="activator"
                            label="Time Picker"
                            v-model="currentTransfer.transferTime"
                            prepend-icon="access_time"
                            readonly></v-text-field>
              <v-time-picker v-model="currentTransfer.transferTime" actions>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="timemenuvisibilty = false">Cancel</v-btn>
                <v-btn flat color="primary" @click="$refs.timemenu.save(currentTransfer.transferTime)">OK</v-btn>
              </v-time-picker>
            </v-dialog>
          </v-flex>
          <v-flex xs12>
            <v-select v-bind:items="paymentType"
                      v-model="currentTransfer.paymentType"
                      label="Payment Type"
                      chips
                      :error-messages="paymentTypeErrors"
                      @input="$v.currentTransfer.paymentType.$touch()"
                      @blur="$v.currentTransfer.paymentType.$touch()"></v-select>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
  import { validationMixin } from 'vuelidate'
  import { required, minValue } from 'vuelidate/lib/validators'

  import { globalFunctions } from '../../javascript/globalFunctions'
  import { transferManager } from '../../javascript/transferManager'

  export default {
    mixins: [validationMixin],
    props: ['drawer'],
    data() {
      return {
        paymentType: ["Cash", "Credit Card", "Debit Card", "Bank Transfer", "Voucher"],
        category: ["cat1", "cat2", "cat3", "cat4"],
        currency: ["JMD", "USD"],
        account: [],
        datemenu: false,
        timemenuvisibilty: false,
        currentTransfer: {
          id: 0,
          currency: '',
          transferName: '',
          category: '',
          transferAmount: 0,
          comment: '',
          paymentType: '',

          transferFrom: '',
          transferTo: '',

          transferDate: '',
          transferTime: null,
          
          //State of Current Object
          objectState: 'New'
        },
        transferItems: []
      }
    },
    computed: {
      transferFromErrors() {
        const errors = []
        if (!this.$v.currentTransfer.transferFrom.$dirty) return errors
        !this.$v.currentTransfer.transferFrom.required && errors.push('Tranfer from is required')
        return errors
      },
      transferToErrors() {
        const errors = []
        if (!this.$v.currentTransfer.transferTo.$dirty) return errors
        !this.$v.currentTransfer.transferTo.required && errors.push('Tranfer to is required')
        if (this.currentTransfer.transferTo === this.currentTransfer.transferFrom) errors.push('Cannot tranfer to the same Account')
        return errors
      },
      categoryErrors() {
        const errors = []
        if (!this.$v.currentTransfer.category.$dirty) return errors
        !this.$v.currentTransfer.category.required && errors.push('Category is required')
        return errors
      },
      transferAmountErrors() {
        const errors = []
        if (!this.$v.currentTransfer.transferAmount.$dirty) return errors
        !this.$v.currentTransfer.transferAmount.minValue && errors.push('Transfer Amount must be at least 1')
        return errors
      },
      currencyErrors() {
        const errors = []
        if (!this.$v.currentTransfer.currency.$dirty) return errors
        !this.$v.currentTransfer.currency.required && errors.push('Currency is required')
        return errors
      },
      transferNameErrors() {
        const errors = []
        if (!this.$v.currentTransfer.transferName.$dirty) return errors
        !this.$v.currentTransfer.transferName.required && errors.push('Transfer Name is required')
        return errors
      },
      paymentTypeErrors() {
        const errors = []
        if (!this.$v.currentTransfer.paymentType.$dirty) return errors
        !this.$v.currentTransfer.paymentType.required && errors.push('Payment Type is required')
        return errors
      }
    },
    methods: {
      updateDateAndTime: function () {
        this.currentTransfer.transferDate = globalFunctions.getCurrentDateForPicker()
        this.currentTransfer.transferTime = globalFunctions.getCurrentTimeForPicker()
      },
      buildAccountSelect: function () {
        let tempAccount = this.$store.state.Accounts

        this.account.push({ header: 'Accounts' })

        for (let i = 0; i < tempAccount.length; i++) {
          this.account.push(tempAccount[i])
        }
        

        //let group = this.$store.state.Groups

        //if (group.length > 0) {
        //  this.account.push({ header: 'Groups' })

        //  for (let i = 0; i < group.length; i++) {
        //    this.account.push(group[i])
        //  }
        //}

      },
      transferCheck: function ($v) {
        $v.$touch(); //Triggers Error Messages

        if (this.currentTransfer.transferAmount < 0 || !globalFunctions.isIntOrFloat(this.currentTransfer.transferAmount) || this.currentTransfer.transferAmount === "") { this.currentTransfer.transferAmount = 0 }

        if ($v.transferFrom.$invalid || $v.transferTo.$invalid || $v.category.$invalid || $v.transferAmount.$invalid || $v.currency.$invalid || $v.paymentType.$invalid) {
          return false
        }
        
        return true
      },
      addTransferCheck: function ($v) {
        if (this.transferCheck($v)) {
          this.addTransfer()
        }
      },
      addTransfer() {
        transferManager.addTransfer(this.currentTransfer)

        this.createTransactionIfNeeded()

        this.$router.push({ path: '/dashboard/transfer' })
      },
      createTransactionIfNeeded: function () {
        if (this.checkIfTransactionIsNeeded) {
          transferManager.createTransactionFromTransfer(this.currentTransfer)
        }
      },
      checkIfTransactionIsNeeded: function () {
        let today = new Date()
        let transferTime = new Date(this.currentTransfer.transferDate)

        if (today.getTime() === transferTime.getTime()) {
          return true
        }

        return false
      },
      selectedCurrencyChanged: function () {
        ///////////////////////////////////////////////////////
        //Go Through Each Transaction Item 
        ///////////////////////////////////////////////////////

        //for (let i = 0; i < this.transferItems.length; i++) {
        //  ////////////////////////////////////////////////////////////////
        //  //Loop conversions and test if currency already found
        //  ///////////////////////////////////////////////////////////////

        //  for (let x = 0; x < this.conversions.length; x++) {
        //    if (this.transactionItems[i].itemCurrency === this.conversions[x]) {
        //      break
        //    } else if (x === this.conversions.length - 1) {
        //      this.getConversion(this.transactionItems[i].itemCurrency)
        //    }
        //  }
        //}
      }
    },
    beforeMount() {

      this.transferItems = this.$store.state.Transfers

      let cat = this.$store.state.Categories
      for (let i = 0; i < cat.length; i++) {
        this.category.push(cat[i].categoryName)
      }

      let cur = this.$store.state.Currencies
      for (let i = 0; i < cur.length; i++) {
        this.currency.push(cur[i].currencyName)
      }

      this.updateDateAndTime()
      this.buildAccountSelect()
    },
    validations: {
      currentTransfer: {
        transferName: {
          required
        },
        category: {
          required
        },
        transferAmount: {
          required,
          minValue: minValue(1)
        },
        transferDate: {
          required
        },
        transferTime: {
          required
        },
        paymentType: {
          required
        },
        currency: {
          required
        },
        transferFrom: {
          required
        },
        transferTo: {
          required
        }
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/transfer/AddTransfers.vue